// - Name, subject
// - Show received emails list, not received email list
// - Actions: Sent email

import React, { useEffect, useState } from 'react';
import { getEmails } from '../../actions/emailActions';
import { getEmailTemplates } from '../../actions/emailTemplateAction';
import CAlert from '../../components/sharedComponents/CAlert';
import EmailLayout from '../../components/Email/EmailLayout';
import { Table } from 'reactstrap';
import { getUsers } from '../../actions/usersActions';
import { readableDateFormat } from '../../components/shareFunctions';
import ListViewModal from './ListViewModal';
import { renderUserDetailsCol, renderTemplateDetailsCol } from './emailSharedFuncs';

const SentEmailList = ({ authenticated, userDetails }) => {

    const [sentEmailList, setSentEmailList] = useState([])
    const [templateList, setTemplateList] = useState([])
    const [userList, setUserList] = useState([])
    const [isLoading, setIsloading] = useState(true)
    const [errorText, setErrorText] = useState(null)

    useEffect(() => {
        setIsloading(true)

        const fetchData = async () => {
            await getEmails(setSentEmailList, renderError)
            await getUsers(setUserList, renderError)
            await getEmailTemplates(setTemplateList, renderError)
        }
        fetchData();

        setIsloading(false)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    function renderError(err) {
        setErrorText(err)
        isLoading && setIsloading(false)
        return
    }

    return <EmailLayout title='Sent Emails' isLoading={isLoading} fixHeight>
        <CAlert show={errorText !== null} text={errorText} color='danger' />

        <Table borderless hover responsive striped style={{ display: 'table' }}>
            <thead>
                <tr>
                    <th>#</th>
                    <th>Sender</th>
                    <th>Template</th>
                    <th>Sent Info</th>
                </tr>
            </thead>
            <tbody>
                {React.Children.toArray(
                    sentEmailList.map((m, mIndex) =>
                        <tr>
                            <th scope="row">{mIndex + 1}</th>
                            <td>{renderUserDetailsCol(m.user_id, userList)}</td>
                            <td>{renderTemplateDetailsCol(m.email_template_id, templateList, userList)}</td>
                            <td>{renderSentCol(m)}</td>
                        </tr>)
                )}

            </tbody>
        </Table>
    </EmailLayout >

    function renderSentCol({ _id, sent_to, accepted, rejected, status, createdAt }) {
        const statusColor = status ? status === 'SENT' ? '#155724' : '#856404' : '#5a5a5a'
        const statusBGColor = status ? status === 'SENT' ? '#d4edda' : '#fff3cd' : '#b3b3b37a';
        const statusBDColor = status ? status === 'SENT' ? '#c3e6cb' : '#ffeeba' : '#b3b3b37a';
        status && status === 'SENDING' && console.log('_id', _id)
        return <>
            {readableDateFormat(createdAt)}
            <div style={{ padding: '0.3rem' }} />
            <div style={{
                opacity: '0.8',
                fontSize: '0.75rem',
                fontWeight: 'bold',
                padding: '3px 4px 3.5px',
                width: 'fit-content',
                backgroundColor: statusBGColor,
                border: `1px solid ${statusBDColor}`,
                borderRadius: '5px',
                color: statusColor,
                cursor: 'pointer',
                textTransform: 'uppercase'
            }}>
                {status || 'NOT SET'}
            </div>
            <div>
                <span style={{
                    opacity: '0.5',
                    fontSize: '0.75rem',
                    textTransform: 'uppercase'
                }}>Recipients:</span>
                <ListViewModal
                    modalTitle='Recipients'
                    childrenComponent={sent_to.map(m => <li>{m}</li>)}
                    triggerButtonComponent={<span style={{
                        margin: '0px 4px',
                        padding: '3px 4px 3.5px',
                        width: 'fit-content',
                        backgroundColor: '#b3b3b37a',
                        borderRadius: '5px',
                        color: '#5a5a5a',
                        cursor: 'pointer'
                    }}>
                        {sent_to.length}
                    </span>} />
            </div>

            <div>
                <span style={{
                    opacity: '0.5',
                    fontSize: '0.75rem',
                    textTransform: 'uppercase'
                }}>Accepted:</span>
                <ListViewModal
                    modalTitle='Accepted List'
                    childrenComponent={accepted?.map(m => <li>{m}</li>)}
                    triggerButtonComponent={<span style={{
                        margin: '0px 4px',
                        padding: '3px 4px 3.5px',
                        width: 'fit-content',
                        backgroundColor: '#b3b3b37a',
                        borderRadius: '5px',
                        color: '#5a5a5a',
                        cursor: 'pointer'
                    }}>
                        {accepted?.length}
                    </span>} />
            </div>

            <div>
                <span style={{
                    opacity: '0.5',
                    fontSize: '0.75rem',
                    textTransform: 'uppercase'
                }}>Rejected:</span>
                <ListViewModal
                    modalTitle='Rejected List'
                    childrenComponent={rejected?.map(m => <li>{m}</li>)}
                    triggerButtonComponent={<span style={{
                        margin: '0px 4px',
                        padding: '3px 4px 3.5px',
                        width: 'fit-content',
                        backgroundColor: '#b3b3b37a',
                        borderRadius: '5px',
                        color: '#5a5a5a',
                        cursor: 'pointer'
                    }}>
                        {rejected?.length}
                    </span>} />
            </div>
        </>
    }


}

export default SentEmailList;